import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, inject } from 'vue';

import {
  InputStep,
  SingleInput,
  ShortcutValue,
  BaseText,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { isValidDate, getFutureDate } from './helpers/dateValidation';
import {
  EStatusType,
  ESuggestedPortfolioBuilderSteps
} from '@/modules/wealth/views/SuggestedPortfolioBuilder/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'GoalDate',
  setup(__props) {

const changeStep = inject(
  'changeStep',
  (step: ESuggestedPortfolioBuilderSteps) => ({ step })
);
const saveGoalDate = inject('saveGoalDate', (value: string) => ({ value }));

const injectGoalDate = inject('goalDate') as string;
const isLoading = inject('isLoading') as boolean;

const getPortfolios = inject('getPortfolios', () => ({}));

const goalDate = ref(injectGoalDate);
const singleHelperText = ref('');
const singleInputStatus = ref(EStatusType.DEFAULT);

const shortcutData = [
  { value: 1, formatted: 'Até 1 ano' },
  { value: 3, formatted: '1 a 3 anos' },
  { value: 5, formatted: '3 a 5 anos' },
  { value: 10, formatted: '5+ anos' }
];

watch(goalDate, () => {
  const { isValid, error } = isValidDate(goalDate.value);

  singleHelperText.value = error;
  singleInputStatus.value = isValid ? EStatusType.DEFAULT : EStatusType.ERROR;
});

const isDisabled = computed(
  () => singleInputStatus.value === EStatusType.ERROR || !goalDate.value
);

function handleChange(value: string) {
  let formattedDate = value;

  if (formattedDate.length > 10) {
    formattedDate = value.slice(0, -1);
  }

  formattedDate = formattedDate.replace(/\D/g, '');
  formattedDate = formattedDate.replace(/(\d{2})(\d)/, '$1/$2');
  formattedDate = formattedDate.replace(/(\d{2})(\d)/, '$1/$2');

  goalDate.value = formattedDate;
}

function onClear() {
  goalDate.value = '';
}

function shortcutClick(data: { value: number; formatted: string }) {
  goalDate.value = getFutureDate(data.value);
}

function onBack() {
  saveGoalDate(goalDate.value);

  changeStep(ESuggestedPortfolioBuilderSteps.INITIAL_INVESTMENT);
}

function onClick() {
  saveGoalDate(goalDate.value);

  getPortfolios();
}

return { __sfc: true,changeStep, saveGoalDate, injectGoalDate, isLoading, getPortfolios, goalDate, singleHelperText, singleInputStatus, shortcutData, isDisabled, handleChange, onClear, shortcutClick, onBack, onClick, InputStep, SingleInput, ShortcutValue, BaseText, ButtonContainer, ButtonPrimary, NebraskaColors }
}

})